import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CustomChip from "./CustomChip.js";

const styleCard = {
  width: "90%",
  height: "auto",
  marginTop: "20px",
  background: "linear-gradient(45deg, #32323e, #595a60)",
  color: "white",
  padding: 0,
  position: "relative",
  overflow: "hidden",
  "&:before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "80px", // Ancho de la línea
    height: "80px", // Altura de la línea
    background: "#ffc107", // Color amarillo
    clipPath: "polygon(0 0, 100% 0, 0 100%)", // Forma diagonal
  },
};

const CardCertifications = ({ isMobile = false }) => (
  <>
    <p className="text-white text-[17px] font-semibold">Certificaciones</p>

    <div className={`${!isMobile ? "grid grid-cols-2 gap-4" : ""}`}>
      <Card sx={styleCard}>
        <CardContent sx={{ padding: 0 }}>
          <p className="text-white text-sm text-center mt-2 font-semibold">
            TOELF ITP
          </p>

          <ul className="mt-6 space-y-4">
            <li className="grid grid-cols-[70%_25%]">
              <div className="flex ml-[15%]">
                <div className="w-3 h-3 bg-yellow-400 rounded-full mt-2"></div>
                <div className="ml-2">
                  <p className="text-sm  text-main">Listening Comprehension</p>
                  <p className="text-sm text-main">Comprensión auditiva</p>
                </div>
              </div>

              <div className="mt-2 ml-7">
                <p className="text-sm font-bold text-white ml-3">51</p>
              </div>
            </li>

            <li className="grid grid-cols-[70%_25%]">
              <div className="flex ml-[15%]">
                <div className="w-3 h-3 bg-yellow-400 rounded-full mt-2"></div>
                <div className="ml-2">
                  <p className="text-sm  text-main">
                    Structure & Written Expression
                  </p>
                  <p className="text-sm text-main">
                    Gramática y expresión escrita
                  </p>
                </div>
              </div>

              <div className="mt-2 ml-7">
                <p className="text-sm font-bold text-white ml-3">46</p>
              </div>
            </li>

            <li className="grid grid-cols-[70%_25%]">
              <div className="flex ml-[15%]">
                <div className="w-3 h-3 bg-yellow-400 rounded-full mt-2"></div>
                <div className="ml-2">
                  <p className="text-sm  text-main">Reading Comprehension</p>
                  <p className="text-sm text-main">Comprensión lectora</p>
                </div>
              </div>

              <div className="mt-2 ml-7">
                <p className="text-sm font-bold text-white ml-3">52</p>
              </div>
            </li>

            <li className="grid grid-cols-[70%_25%]">
              <div className="flex ml-[15%]">
                <div className="w-3 h-3 bg-yellow-400 rounded-full mt-2"></div>
                <div className="ml-2">
                  <p className="text-sm  text-main">Score Total</p>
                  <p className="text-sm text-main">Puntuación Total</p>
                </div>
              </div>

              <div className="mt-2 ml-7">
                <CustomChip label="497" />
              </div>
            </li>
          </ul>
        </CardContent>
      </Card>

      <Card sx={styleCard}>
        <CardContent sx={{ padding: 0 }}>
          <p className="text-white text-sm text-center mt-2 font-semibold">
            EUROEXAM Level B1
          </p>

          <ul className="mt-6 space-y-4">
            <li className="grid grid-cols-[70%_25%]">
              <div className="flex ml-[15%]">
                <div className="w-3 h-3 bg-yellow-400 rounded-full mt-2"></div>
                <div className="ml-2">
                  <p className="text-sm  text-main">Reading</p>
                  <p className="text-sm text-main">Comprensión lectora</p>
                </div>
              </div>

              <div className="mt-2 ml-7">
                <p className="text-sm font-bold text-white ml-3">75%</p>
              </div>
            </li>

            <li className="grid grid-cols-[70%_25%]">
              <div className="flex ml-[15%]">
                <div className="w-3 h-3 bg-yellow-400 rounded-full mt-2"></div>
                <div className="ml-2">
                  <p className="text-sm text-main">Written</p>
                  <p className="text-sm text-main">
                    Gramática y expresión escrita
                  </p>
                </div>
              </div>

              <div className="mt-2 ml-7">
                <p className="text-sm font-bold text-white ml-3">97%</p>
              </div>
            </li>

            <li className="grid grid-cols-[70%_25%]">
              <div className="flex ml-[15%]">
                <div className="w-3 h-3 bg-yellow-400 rounded-full mt-2"></div>
                <div className="ml-2">
                  <p className="text-sm  text-main">Listening</p>
                  <p className="text-sm text-main">Comprensión auditiva</p>
                </div>
              </div>

              <div className="mt-2 ml-7">
                <p className="text-sm font-bold text-white ml-3">48%</p>
              </div>
            </li>

            <li className="grid grid-cols-[70%_25%]">
              <div className="flex ml-[15%]">
                <div className="w-3 h-3 bg-yellow-400 rounded-full mt-2"></div>
                <div className="ml-2">
                  <p className="text-sm  text-main">Score Total</p>
                  <p className="text-sm text-main">Puntuación Total</p>
                </div>
              </div>

              <div className="mt-2 ml-7">
                <CustomChip label="73%" />
              </div>
            </li>
          </ul>
        </CardContent>
      </Card>
    </div>
  </>
);

export default CardCertifications;
